'use client';

import { updateNumberOfQuestions } from '@/lib/redux/features/number-of-questions-slice';
import { useAppDispatch, useAppSelector } from '@/lib/redux/hooks';
import { RootState } from '@/lib/redux/store';
import { SelectChangeEvent } from '@mui/material';

export interface INumberOfQuestionsComponentProps {
  handleChange: (event: SelectChangeEvent<string>) => void;
  numberOfQuestions: number;
}

export const useNumberOfQuestionsComponent = (): INumberOfQuestionsComponentProps => {
  const dispatch = useAppDispatch();
  const numberOfQuestions = useAppSelector((state: RootState) => state.numberOfQuestions);

  const handleChange = (event: SelectChangeEvent<string>) => {
    dispatch(updateNumberOfQuestions(Number.parseInt(event.target.value, 10)));
  };

  return { handleChange, numberOfQuestions };
};

export default useNumberOfQuestionsComponent;
